{
  "title": "Feeblemind",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level enchantment",
  "level": 8,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (a handful of clay, crystal, glass, or mineral spheres)",
  "duration": "Instantaneous",
  "description": [
    "You blast the mind of a creature that you can see within range, attempting to shatter its intellect and personality. The target takes 4d6 psychic damage and must make an Intelligence saving throw.",
    "On a failed save, the creature’s Intelligence and Charisma scores become 1. The creature can’t cast spells, activate magic items, understand language, or communicate in any intelligible way. The creature can, however, identify its friends, follow them, and even protect them.",
    "At the end of every 30 days, the creature can repeat its saving throw against this spell. If it succeeds on its saving throw, the spell ends. The spell can also be ended by Greater Restoration, Heal, or Wish."
  ],
  "spellLists": ["bard", "druid", "warlock", "wizard"]
}
